"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Stepan Mik
 */


var CannibalizationItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CannibalizationItem, _DomainObject_1$Domai);

  function CannibalizationItem(cannibal, victim, amount) {
    var _this;

    _classCallCheck(this, CannibalizationItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CannibalizationItem).call(this));
    _this.cannibal = cannibal;
    _this.victim = victim;
    _this.amount = amount;
    return _this;
  }

  _createClass(CannibalizationItem, null, [{
    key: "deserializeCannibalizationItem",
    value: function deserializeCannibalizationItem(c, conversions) {
      return new CannibalizationItem(CannibalizationItem.schema.cannibal.valueOf(conversions.toClassReferenceId(c.c)), CannibalizationItem.schema.victim.valueOf(conversions.toClassReferenceId(c.v)), CannibalizationItem.schema.amount.valueOf(conversions.toBigNumber(c.a)));
    }
  }, {
    key: "serializeCannibalizationItem",
    value: function serializeCannibalizationItem(c, conversions) {
      return {
        c: conversions.toDocumentReferenceId(c.cannibal),
        v: conversions.toDocumentReferenceId(c.victim),
        a: conversions.fromBigNumber(c.amount)
      };
    }
  }]);

  return CannibalizationItem;
}(DomainObject_1.DomainObject);

exports.CannibalizationItem = CannibalizationItem;

CannibalizationItem.schema = function () {
  var bld = new StructPropBuilder_1.StructPropBuilder(CannibalizationItem.name);
  return {
    cannibal: bld.id('c'),
    victim: bld.id('v'),
    amount: bld.bigNum('a')
  };
}();